import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GroupHotelGuardService } from 'src/app/services/guards/group-hotel-guard.service';
import { ConciergeComponent } from '../components/concierge/concierge.component';
import { DetailPageComponent } from '../components/detail-page/detail-page.component';
import { LiveRequestComponent } from '../components/live-request/live-request.component';
import { MessagesComponent } from '../components/messages/messages.component';
import { ProfileComponent } from '../components/profile/profile.component';
import { ServicesComponent } from '../components/services/services.component';
import { TabsPage } from './tabs.page';
import { ChatComponent } from '../components/chat/chat.component';

const routes: Routes = [
  {
    path: '',
    component: TabsPage,
    children: [
      {
        path: 'home',
        canActivate: [GroupHotelGuardService],
        loadChildren: () =>
          import('../home/home.module').then((m) => m.HomePageModule),
      },
      {
        path: 'profile',
        component: ProfileComponent,
      },
      {
        path: 'chat',
        component: MessagesComponent,
      },
      {
        path: 'live-support',
        component: ChatComponent,
        data: {
          header: null,
          live: true,
        },
      },
      {
        path: 'concierge',
        component: ConciergeComponent,
      },
      {
        path: 'services',
        component: ServicesComponent,
      },
      {
        path: 'services/l/:section/:item',
        component: LiveRequestComponent,
      },
      {
        path: 'services/:section/:item',
        component: DetailPageComponent,
      },
      {
        path: 'concierge/:section/:item',
        component: DetailPageComponent,
      },
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [GroupHotelGuardService],
})
export class TabsPageRoutingModule {}
